type ParallaxOnScroll = {
  element: HTMLElement;
  speed: number;
  direction?: 'up' | 'down';
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function parallaxOnScroll({ element, speed, direction = 'up' }: ParallaxOnScroll) {
  const distance = window.scrollY * speed;
  if (element?.style) {
    // eslint-disable-next-line no-param-reassign
    element.style.transform = `translateY(${direction === 'down' ? '' : '-'}${distance}px)`;
  }
}
